module.exports = __webpack_public_path__ + "static/media/twitterX-community.31584716.svg";